import React from "react";
import { SchemePortfolioItem } from "@/type/schemeType";

export default function AllCompaniesAllocations({ items }: { items: SchemePortfolioItem[] }) {
  // Decide chunk size based on total items
  let chunkSize = 10;
  if (items.length > 60) {
    chunkSize = 40;
  } else if (items.length > 30) {
    chunkSize = 20;
  }

  // Split into chunks
  const chunkedItems: SchemePortfolioItem[][] = [];
  for (let i = 0; i < items.length; i += chunkSize) {
    chunkedItems.push(items.slice(i, i + chunkSize));
  }

  return (
    <div className="bg-white p-5 md:p-6 rounded-4xl border border-[#E9E9EB]">
      <div className="flex flex-col md:flex-row" style={{ gridTemplateColumns: `repeat(${chunkedItems.length}, minmax(0, 1fr))` }}>
        {chunkedItems.map((chunk, colIndex) => (
          <div key={colIndex} className="flex-1 md:border-r border-[#E9E9EB] md:px-6 md:last-of-type:border-none md:first-of-type:pl-0 md:last-of-type:pr-0">
            {chunk.map((item, index) => (
              <div key={index} className="mb-4 md:last-of-type:mb-0">
                <div className="flex justify-between text-base text-[#444444] font-medium">
                  <span>{item.instrument}</span>
                  <span className="text-primaryBlack">{Number(item?.holdings || 0).toFixed(3)}%</span>
                </div>
                <div className="w-full bg-[#C4CFEE66] h-3 rounded-[50px] mt-2">
                  <div className="bg-[#657DFF] h-3 rounded-[50px]" style={{ width: `${item.holdings?item.holdings+5:0}%` }} />
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
